module.exports = __webpack_public_path__ + "img/screen_icon.ea8010a9.png";